"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _sliderControl = _interopRequireDefault(require("./slider-control.css"));
var _excluded = ["className", "disabled", "type", "theme"];
var SliderControl = /*#__PURE__*/function (_React$PureComponent) {
  function SliderControl() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  (0, _inheritsLoose2["default"])(SliderControl, _React$PureComponent);
  var _proto = SliderControl.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      className = _this$props.className,
      disabled = _this$props.disabled,
      type = _this$props.type,
      theme = _this$props.theme,
      btnProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, _excluded);
    var iconClassName = type === 'next' ? _sliderControl["default"].iconRight : _sliderControl["default"].iconLeft;
    return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
      type: "button",
      className: className,
      disabled: disabled
    }, btnProps), /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _clsx["default"])(theme.light, _sliderControl["default"].sliderControlInner)
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: iconClassName
    })));
  };
  return SliderControl;
}(_react["default"].PureComponent);
SliderControl.displayName = 'SliderControl';
SliderControl.defaultProps = {
  disabled: false
};
var _default = exports["default"] = SliderControl;